const apiHost = process.env.REACT_APP_DB_HOST;
const newsHost = process.env.REACT_APP_NEWS_HOST;

/*========================================================================
* KM
========================================================================*/
// User
const KmListApi = apiHost + '/api/km/user/list'; // 검색 및 페이징
const KmSubApi = apiHost + '/api/km/user/submenu'; // 하위 메뉴 리스트 조회
const KmSgApi = apiHost + '/api/km/user/view'; // 상세 게시물 조회
const KmCatApi = apiHost + '/api/km/user/group'; // KM 카테고리 조회 [GET]
// Admin
const AdKmApi = apiHost + '/api/km'; // Admin POST, PUT, DELETE
const AdKmGetApi = apiHost + '/api/km/list'; // Admin GET 검색 및 페이징
const AdKmSgApi = apiHost + '/api/km/view'; // 상세 게시물 조회
const AdKmCatApi = apiHost + '/api/km/group' // Admin KM 카테고리 [GET, POST, PUT, DELETE]
const AdKmCatUseApi = apiHost + '/api/km/group/use' // Admin KM 카테고리 노출 여부 변경 [PUT]
const AdKmUploadApi = apiHost + '/api/km/upload' // KM 이미지 업로드
const AdkmUseApi = apiHost + '/api/km/use' // KM 사용 여부 변경 [PUT]
const AdKmIdxApi = apiHost + '/api/km/index' // KM Drag & Drop Index 변경 [PUT]


/*========================================================================
* News [KM, PayGate 뉴스 통합]
========================================================================*/
// User
// const NewsListApi = apiHost + '/api/news/user/list'; // 검색 및 페이징
const NewsListApi = newsHost + '/api/news/user' // 통합 News 검색 및 페이징
// const NewsSgApi = apiHost + '/api/news/user/view'; // 게시물 상세 조회
const NewsSgApi = newsHost + '/api/news/user/view'; // 통합 News 게시물 상세 조회

// Admin
// const AdNewsListApi = apiHost + '/api/news/list'; // GET 검색 및 페이징
const AdNewsListApi = newsHost + '/api/news'; // 통합 News GET 검색 및 페이징
const AdNewsApi = apiHost + '/api/news'; // News POST, PUT, DELETE 
// const AdNewsSgApi = apiHost + '/api/news/view'; // 게시물 상세 조회
const AdNewsSgApi = newsHost + '/api/news/view'; // 통합 News 게시물 상세 조회
// const AdNewsCatApi = apiHost + '/api/news/category'; // News 카테고리
const AdNewsCatApi = newsHost + '/api/news/category'; // 통합 News 카테고리
// const AdNewsUploadApi = apiHost + '/api/news/upload'; // News 이미지 업로드
const AdNewsUploadApi = newsHost + '/api/news/upload'; // 통합 News 이미지 업로드
const AdNewsUseApi = apiHost + '/api/news/use'; // News 사용 여부 변경



/*========================================================================
* Development Guide
========================================================================*/
// User
const PolicyApi = apiHost + '/api/guide/policy/user/list'; 
const RegApi = apiHost + '/api/guide/regulation/user/list';
// Admin
const AdPolicyListApi = apiHost + '/api/guide/policy/list'; // Security-Policy 목록 조회 [GET]
const AdPolicyApi = apiHost + '/api/guide/policy'; // Security-Policy [POST, PUT, DELETE]
const AdPolicyUseApi = apiHost + '/api/guide/policy/use'; // Security-Policy 사용 여부 PUT
const AdPolicySgApi = apiHost + '/api/guide/policy/view'; // Security-Policy 게시물 상세 조회
const AdRegListApi = apiHost + '/api/guide/regulation/list'; // Development-Regulation 목록 조회 [GET]
const AdRegApi = apiHost + '/api/guide/regulation'; // Development-Regulation [POST, PUT, DELETE]
const AdRegUseApi = apiHost + '/api/guide/regulation/use'; // Development-Regulation 사용 여부 PUT
const AdRegSgApi = apiHost + '/api/guide/regulation/view'; // Development-Regulation 게시물 상세 조회


/*========================================================================
* FAQ
========================================================================*/
// User
const FaqListApi = apiHost + '/api/support/faq/user/list' // FAQ GET 검색 및 페이징
// Admin
const AdFaqApi = apiHost + '/api/support/faq' // FAQ POST, PUT, DELETE
const AdFaqListApi = apiHost + '/api/support/faq/list' // FAQ GET 검색 및 페이징
const AdFaqUseApi = apiHost + '/api/support/faq/use' // FAQ 사용 여부 PUT
const AdFaqSgApi = apiHost + '/api/support/faq/view' // FAQ 게시물 상세 조회


/*========================================================================
* Developer Support
========================================================================*/
// User
const SupportReqApi = apiHost + '/api/support/user/request' // POST Support Request 요청
const SupportCatApi = apiHost + '/api/support/request/user/category' // Developer Support Category
// Admin
const AdSupportListApi = apiHost + '/api/support/request/list' // Developer Support 목록 조회
const AdSupportCatApi = apiHost + '/api/support/request/category' // Developer Support Category
const AdSupportCatUseApi = apiHost + '/api/support/request/category/use' // Developer Support Category 사용 여부 변경
const AdSupportApi = apiHost + '/api/support/request' // Developer Support PUT, DELETE
const AdSupportAnsApi = apiHost + '/api/support/request/answer' // Developer Support 답변하기
const AdSupportSgApi = apiHost + '/api/support/request/view' // Developer Support 문의 상세 조회


/*========================================================================
* Conference
========================================================================*/
// User
const CoListApi = apiHost + '/api/connect/conference/user/list' // Conference 목록 조회 
// Admin
const AdCoListApi = apiHost + '/api/connect/conference/list' // Conference 목록 조회
const AdCoApi = apiHost + '/api/connect/conference' // Conference [POST, PUT, DELETE]
const AdCoCatApi = apiHost + '/api/connect/conference/category' // Conforence 카테고리 
const AdCoUploadApi = apiHost + '/api/connect/conference/upload' // Conference 이미지 업로드
const AdCoUseApi = apiHost + '/api/connect/conference/use' // Conference 사용 여부 변경
const AdCoSgApi = apiHost + '/api/connect/conference/view' // Conference 게시물 상세 조회


/*========================================================================
* Developer Employ (개발자 채용)
========================================================================*/
// User
const IncruitApi = apiHost + '/api/incruit/user/list' // 채용 글 리스트 검색 및 페이징
const JoinPostApi = apiHost + '/api/join/user' // 입사 지원하기 메일 발송
const JoinListApi = apiHost + '/api/join/user/list' // 입사 지원 목록 조회 [POST]
const JoinSgApi = apiHost + '/api/join/user/view' // 지원자 상세 조회

// Admin
const AdIncruitApi = apiHost + '/api/incruit' // 채용 글 리스트 POST, PUT, DELETE
const AdIncruitListApi = apiHost + '/api/incruit/list' // 채용 글 리스트 검색 및 페이징
const AdIncruitSgApi = apiHost + '/api/incruit/view' // 채용 글 상세 조회
const AdIncruitUseApi = apiHost + '/api/incruit/use' // 채용 글 리스트 사용 여부 변경
const AdIncruitCatApi = apiHost + '/api/incruit/category' // 채용 글 리스트 Catogory
const AdJoinListApi = apiHost + '/api/incruit/join_list' // 특정 채용 글의 지원자 조회
const AdJoinApi = apiHost + '/api/join' // 전체 지원자 조회, 수정, 삭제
const AdJoinStatusApi = apiHost + '/api/join/status' // 지원자 상태 변경 [PUT]


/*========================================================================
* 회원 관리
========================================================================*/
// 회원 리스트 관리
const MemApi = apiHost + '/api/Admin/account' // 회원 계정 조회
const MemRolesApi = apiHost + '/api/Admin/account/roles' // 회원 권한 리스트 조회
const MemSgApi = apiHost + '/api/Admin/account/view' // 현재 회원 계정 상세 조회
const MemUseApi = apiHost + '/api/Admin/account/use' // 회원 계정 사용 여부 변경
const MemSignupApi = apiHost + '/api/Admin/account/signup' // 회원 계정 등록
const MemLoginUseApi = apiHost + '/api/Admin/account/login/use' // 회원 로그인 사용 여부 요청 [PUT] 

// 회원 로그인 및 Session 관리
const MemLoginApi = apiHost + '/api/Admin/account/signin' // 일반 로그인
const MemSfrtLoginApi = apiHost + '/api/Admin/account/signin/jwt' // Seyfert 인증센터 로그인
const MemSessionApi = apiHost + '/api/Admin/account/sessionID' // 회원 Session ID 발급
const MemLoginChkApi = apiHost + '/api/Admin/account/signin/jwt/loginCheck' // 로그인(Session) 상태 체크
const MemSessionReApi = apiHost + '/api/Admin/account/signin/jwt/resetTime' // 세션 기간 연장
const MemLogoutApi = apiHost + '/api/Admin/account/signin/jwt/logOut' // 로그아웃


/*========================================================================
* 고객 관리
========================================================================*/
// 고객 리스트 관리
const CmApi = apiHost + '/api/Customer/account' // 고객 계정 조회, 수정, 삭제 [GET, PUT, DELETE]
const CmSignupApi = apiHost + '/api/Customer/account/signup' // 고객 계정 등록
const CmGradeApi = apiHost + '/api/Customer/account/grade' // 고객 권한 리스트 조회
const CmSgApi = apiHost + '/api/Customer/account/view' // 현재 고객 계정 상세 조회
const CmUseApi = apiHost + '/api/Customer/account/use' // 고객 계정 사용 여부 PUT

// 고객 로그인 및 고객 등록
const CmLoginApi = apiHost + '/api/Customer/account/signin' // 로그인
const CmRePassApi = apiHost + '/api/Customer/account/pass' // 비밀번호 변경
const CmLoginChkApi = apiHost + '/api/Customer/account/signin/loginCheck' // 로그인 상태 체크
const CmLogoutApi = apiHost + '/api/Customer/account/signin/logOut' // 로그아웃
const CmSessionApi = apiHost + '/api/Customer/account/sessionID' // 고객 Session ID 발급
const CmSessionReApi = apiHost + '/api/Customer/account/signin/resetTime' // 세션 기간 연장


/*========================================================================
* 검토/승인 관리
========================================================================*/
const ReviewAprvApi = apiHost + '/api/Admin/account/approver' // 검토/승인자 목록 [GET, PUT]
const ReviewAprvSelfApi = apiHost + '/api/Admin/account/approver/self' // 본인 검토/승인자 조회 [GET]
const ReviewAprvUpApi = apiHost + '/api/Admin/account/approver/up' // 검토/승인자 등록 가능 회원 추가 [PUT]

const ApprListApi = apiHost + '/api/approve/list' // 검토/승인 관리 목록 조회 [GET]
const ApprHistoryApi = apiHost + '/api/approve/history/list' // 검토/승인 요청 목록 조회 [GET]
const ApprSpecifie = apiHost + '/api/approve/specifie' // 검토 완료 처리 [POST]
const ApprApporve = apiHost + '/api/approve/approve' // 승인 완료 처리 [POST]
const ApprRefer = apiHost + '/api/approve/refer' // 검토/승인 반려 처리 [DELETE]



module.exports = {
    apiHost,
    KmListApi, KmSubApi, KmSgApi, KmCatApi, AdKmApi, AdKmGetApi, AdKmSgApi, AdKmCatApi, AdKmCatUseApi, AdKmUploadApi, AdkmUseApi, AdKmIdxApi,
    NewsListApi, NewsSgApi, AdNewsListApi, AdNewsApi, AdNewsSgApi, AdNewsCatApi, AdNewsUploadApi, AdNewsUseApi,
    PolicyApi, RegApi, AdPolicyListApi, AdPolicyApi, AdRegListApi, AdRegApi, AdPolicyUseApi, AdRegUseApi, AdPolicySgApi, AdRegSgApi,
    FaqListApi, AdFaqApi, AdFaqUseApi, AdFaqListApi, AdFaqSgApi, SupportReqApi, SupportCatApi, AdSupportListApi, AdSupportApi, AdSupportCatApi, AdSupportCatUseApi, AdSupportAnsApi, AdSupportSgApi,
    AdCoListApi, CoListApi, AdCoApi, AdCoCatApi, AdCoUploadApi, AdCoUseApi, AdCoSgApi,
    AdIncruitApi, AdIncruitListApi, AdIncruitUseApi, AdIncruitCatApi, AdJoinListApi, IncruitApi, JoinSgApi, AdJoinApi, JoinPostApi, JoinListApi, AdIncruitSgApi, AdJoinStatusApi,
    MemApi, MemRolesApi, MemSgApi, MemUseApi, // 회원 리스트 관리
    MemLoginApi, MemLoginChkApi, MemLogoutApi, MemSignupApi, MemLoginUseApi, MemSessionReApi, // 회원 로그인 및 회원가입
    MemSfrtLoginApi, MemSessionApi, // 회원 로그인 - Seyfert 인증 센터
    CmApi, CmGradeApi, CmSgApi, CmUseApi, CmSignupApi, // 고객 리스트 관리
    CmLoginApi, CmRePassApi, CmLoginChkApi, CmLogoutApi, CmSessionApi, CmSessionReApi, // 고객 로그인 및 고객 등록
    ReviewAprvApi, ReviewAprvSelfApi, ReviewAprvUpApi, ApprListApi, ApprHistoryApi, ApprSpecifie, ApprApporve, ApprRefer, // 검토/승인 관리
}